import gql from 'graphql-tag'

export const GET_EDUCATIONAL_PULSES = gql`
    query getEducationalPulsesQuery {
        getAvailableEducationalPulses {
            pulseId
            content
        }
    }
`

export const MARK_EDUCATIONAL_PULSE_SEEN = gql`
    mutation markEducationalPulseSeenMutation($pulseId: String!) {
        markEducationalPulseSeen(input: { pulseId: $pulseId }) {
            result
            userErrors {
                field
                message
            }
        }
    }
`
